// extracted by mini-css-extract-plugin
module.exports = {"header":"navbar_header__1FczR"};